export const INTEGRATION_SETTINGS = {
  ably: {
    key: process.env.ABLY_KEY || '',
  },
  gtm: {
    id: process.env.GTM_ID,
  },
  sentry: {
    dsn: process.env.SENTRY_DSN,
  },
} as const;
